'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _aphrodite = require('aphrodite');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _primaryButton = require('./primaryButton');

var _primaryButton2 = _interopRequireDefault(_primaryButton);

var _utils = require('../utils');

var _utils2 = _interopRequireDefault(_utils);

var _colors = require('../colors');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var styles = _aphrodite.StyleSheet.create({
  rounded: {
    borderRadius: 55,
    borderBottom: 'none',
    transform: 'scale(1.0)',
    transition: 'transform 0.18s'
  },
  pseudoClasses: {
    ':active': {
      transform: 'scale(0.98)',
      transition: 'transform 0.1s'
    },
    ':focus': {
      transform: 'scale(0.98)',
      transition: 'transform 0.1s'
    },
    ':hover': {
      backgroundColor: _colors.orange6
    }
  }
});

var RoundedButton = function (_React$Component) {
  _inherits(RoundedButton, _React$Component);

  function RoundedButton() {
    _classCallCheck(this, RoundedButton);

    return _possibleConstructorReturn(this, (RoundedButton.__proto__ || Object.getPrototypeOf(RoundedButton)).apply(this, arguments));
  }

  _createClass(RoundedButton, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_primaryButton2.default, _extends({
        styles: [styles.rounded, styles.pseudoClasses].concat(_toConsumableArray(this.props.styles))
      }, (0, _utils2.default)(this.props)));
    }
  }]);

  return RoundedButton;
}(_react2.default.Component); // FIXME: Remove this duplication.
// We're duplicating these proptypes here so Storybook can properly parse them.
// We should be doing `RoundedButton.propTypes = BasicButton.propTypes` instead.


exports.default = RoundedButton;
RoundedButton.propTypes = {
  /** Event attributes passed to the html (as "data-track=name") */
  track: _propTypes2.default.string,

  /** Event attributes for button presses (as "data-track-button-press=name") */
  trackButtonPress: _propTypes2.default.string,

  /** Event attributes for location (as "data-track-location=name") */
  trackLocation: _propTypes2.default.string,

  /** Whether the button is disabled or not */
  disabled: _propTypes2.default.bool,

  /** Text to be displayed on the button (takes precedence over children) */
  value: _propTypes2.default.node,

  /** Children Component(s) to be displayed as the button text */
  children: _propTypes2.default.node,

  /** Callback triggered onClick */
  onClick: _propTypes2.default.func,

  /** href class passed directly to the link component  */
  href: _propTypes2.default.string,

  /** Extra html properties  */
  html: _propTypes2.default.object,

  /** Aphrodite css overrides */
  styles: _propTypes2.default.array
};
RoundedButton.defaultProps = {
  styles: [],
  track: ''
};